import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { MaterialReactTable } from 'material-react-table';
import { loader_image } from "../_components/Imagepath";

import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from '../Global';
// import Swal from 'sweetalert2';
import $ from "jquery";
import PropTypes from 'prop-types';

const DecayStockFollowUpsWeekly = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const startDate = query.get("start_date");
  const endDate = query.get("end_date");

  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");

  useEffect(() => {
    setPermission(FindModuleById(445));
    console.log(permission);

    axios
      .get(`/helpers/decay-stock-follow-ups-new-weekly?season_id=${season_id}&start_date=${startDate}&end_date=${endDate}`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        setData(response.data.data.stocks);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [startDate, endDate]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  
    const refreshDate = async (situation) => {
     
  
      $("#loader-image-"+situation.id).removeClass('loader-hide');
      $("#loader-image-"+situation.id).addClass('loader-show');
      try {
           await axios.get(`/decay-stock-follow-ups-refresh/${season_id+'-'+situation.id}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          
        }) .then((response) => {
          console.log(response);
          axios
          .get(`/helpers/decay-stock-follow-ups-new-weekly?season_id=${season_id}&start_date=${startDate}&end_date=${endDate}`, {
            headers: {
              Authorization: `Bearer ${Authtoken}`,
              Apitoken: Apitoken,
            },
          })
          .then((response) => {
            setData(response.data.data.stocks);
          })
          .catch((error) => {
            console.log(error);
          });
         $("#loader-image-"+situation.id).addClass('loader-hide');
         $("#loader-image-"+situation.id).removeClass('loader-show');
        })
  
    } catch (error) {
      console.error(error);
    }
  
    }
  const ActionColumn = ({ row }) => {
    return (
      <div>
        <button
          className="btn btn-primary btn-block"
          id={`button-all2-${row.original.id}`}
          onClick={() => refreshDate(row.original)}
        >
          Refresh
          <img
            id={`loader-image-${row.original.id}`}
            className="loader-image loader-hide"
            src={loader_image} // Ensure this is defined
            alt="loading"
          />
        </button>
      </div>
    );
  };
  
  ActionColumn.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };
  
  // ✅ Define ActionCell as a separate component
  const ActionCell = ({ row }) => <ActionColumn row={row} />;
  
  // ✅ Define PropTypes for ActionCell
  ActionCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };
  

  const columns = [
    {
      header: 'Option',
      Cell: ActionCell, // ✅ Pass the validated component directly
    },
   {
      accessorKey: 'date',
      header: 'Date',
    },
    {
      accessorKey: 'materials_decay_net_weight',
      header: 'Farm Decay Wet Weight',
    },
    {
      accessorKey: 'production_net_weight',
      header: 'Production Decay Net Weight',
    },
    {
      accessorKey: 'decalsale_net_weight',
      header: 'Decay Sale Net Weight',
    },
   
    //   {
    //   header: 'Decay Net Weight',
    //   accessorFn: (row) => row.decay_weight || '',
    //   Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
    // },
    
  {
    accessorKey: 'losses',
    header: 'losses',
  },
  ];

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Decay Stock Follow Ups Weekly</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/productions-inventories">Decay Stock Follow Ups</Link>
                    </li>
                    <li className="breadcrumb-item active">Decay Stock Follow Ups Weekly</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div style={{ float: "right" }}>
                          <br /><br />
                          {/* <button onClick={handleDownload} className="btn btn-primary me-1">
                            Download Weekly <i className="fa fa-print" />
                          </button> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <MaterialReactTable
                          columns={columns}
                          data={data}
                          enableColumnOrdering
                          enablePinning
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DecayStockFollowUpsWeekly;
